<ng-container *ngIf="show">
  <ng-container *ngIf="isChecked else unCheckedTmpl">
    <span [ngClass]="{
      'fs-14': true,
      'text-dark': style === 'dark',
      'text-gray': style === 'gray',
      'cursor-pointer': isClickable
    }">
      <i class="far fa-check-square"></i>
    </span>
  </ng-container>
  <ng-template #unCheckedTmpl>
    <span [ngClass]="{
      'fs-14': true,
      'text-dark': style === 'dark',
      'text-gray': style === 'gray',
      'cursor-pointer': isClickable
    }">
      <i class="far fa-square"></i>
    </span>
  </ng-template>
</ng-container>

